(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mitoadaptmode"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('modes-{{ section.id }}');
  if(!root) return;
  var imgEl = root.querySelector('[data-modes-img]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-modes-tab]'));
  var fills = {
    p1: root.querySelector('[data-bar="p1"]'),
    p2: root.querySelector('[data-bar="p2"]'),
    p3: root.querySelector('[data-bar="p3"]'),
    p4: root.querySelector('[data-bar="p4"]'),
    p5: root.querySelector('[data-bar="p5"]'),
    p6: root.querySelector('[data-bar="p6"]'),
    p7: root.querySelector('[data-bar="p7"]'),
    p8: root.querySelector('[data-bar="p8"]')
  };
  var nums = {
    p1: root.querySelector('[data-num="p1"]'),
    p2: root.querySelector('[data-num="p2"]'),
    p3: root.querySelector('[data-num="p3"]'),
    p4: root.querySelector('[data-num="p4"]'),
    p5: root.querySelector('[data-num="p5"]'),
    p6: root.querySelector('[data-num="p6"]'),
    p7: root.querySelector('[data-num="p7"]'),
    p8: root.querySelector('[data-num="p8"]')
  };

  var MAX = 25; // scale bars to 0..25

  function norm(val){
    var f = parseFloat(val);
    if(isNaN(f)) f = 0;
    if(f < 0) f = 0; if(f > MAX) f = MAX;
    return f;
  }

  var panel = root.querySelector('[data-modes-bars]');

  function setActive(tab, opts){
    opts = opts || {};
    tabs.forEach(function(t){
      t.classList.remove('is-active');
      t.setAttribute('aria-selected','false');
      t.setAttribute('tabindex','-1');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-selected','true');
    tab.setAttribute('tabindex','0');
    if(panel) panel.setAttribute('aria-labelledby', tab.id);
    if(opts.focus) tab.focus();

    var src = tab.getAttribute('data-img');
    if(src && imgEl){ imgEl.src = src; imgEl.alt = tab.getAttribute('data-title') || 'Mode image'; }

    ['p1','p2','p3','p4','p5','p6','p7','p8'].forEach(function(key){
      var val = norm(tab.getAttribute('data-' + key));
      var pct = (val / MAX) * 100;
      if(fills[key]){ fills[key].style.width = pct + '%'; }
      if(nums[key]){ nums[key].textContent = val.toFixed(1) + '%'; }
    });
  }

  tabs.forEach(function(tab, i){
    tab.addEventListener('click', function(){ setActive(tab); });
    tab.addEventListener('keydown', function(e){
      var targetIndex = null;
      if(e.key === 'ArrowRight' || e.key === 'ArrowDown') targetIndex = (i + 1) % tabs.length;
      else if(e.key === 'ArrowLeft' || e.key === 'ArrowUp') targetIndex = (i - 1 + tabs.length) % tabs.length;
      else if(e.key === 'Home') targetIndex = 0;
      else if(e.key === 'End') targetIndex = tabs.length - 1;
      if(targetIndex !== null){
        e.preventDefault();
        setActive(tabs[targetIndex], { focus: true });
      }
    });
  });

  // Initialize with the first active tab (or first tab)
  var initial = root.querySelector('.modes__tab.is-active') || tabs[0];
  if(initial) setActive(initial);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mitoaura-clinical-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function animate(section) {
    section.querySelectorAll('.mr-clinical__fill').forEach(function (el) {
      el.style.width = (el.dataset.w || 0) + '%';
    });
  }
  var sections = document.querySelectorAll('.mr-clinical');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    sections.forEach(function (s) { observer.observe(s); });
  } else {
    sections.forEach(animate);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("vwt-video-{{ section.id }}");
  const bar = document.querySelector(
    "#video-with-text-{{ section.id }} .vwt-video-loader-bar"
  );

  if (!video || !bar) return;

  bar.style.width = "90%";

  video.addEventListener("canplaythrough", function () {
    bar.style.width = "100%";
    setTimeout(() => {
      bar.style.opacity = 0;
    }, 300);
  });
});


  } catch(e) { console.error(e); }
})();
})();
